"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _ProductDetailContext = _interopRequireDefault(require("../context/ProductDetailContext"));
var _calculatePercentage = _interopRequireDefault(require("../../utils/calculatePercentage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useTags = () => {
  const {
    productDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const {
    awardTag,
    awardTitle,
    price
  } = productDetailData || {};
  const {
    amount,
    originalAmount
  } = price || {};
  const [tags, setTags] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    let _tags = [];
    if (amount !== originalAmount) {
      _tags.push({
        color: "primary",
        tag: "discount",
        title: "".concat((0, _calculatePercentage.default)(amount, originalAmount), "%")
      });
    }
    if (awardTag && awardTitle) {
      _tags.push({
        color: "default",
        tag: awardTag,
        title: awardTitle
      });
    }
    setTags(_tags);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount, awardTag, awardTitle, originalAmount]);
  return tags;
};
var _default = exports.default = useTags;